import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ApiUrl } from '../constants/apiUrl';
import { Portal } from '../models/entities/portal';
import { ListResponseModel } from '../models/responseModels/list-response-model';
import { ObjectResponseModel } from '../models/responseModels/object-response-model';
import { ResponseModel } from '../models/responseModels/response-model';

@Injectable({
  providedIn: 'root'
})
export class PortalService {

  constructor(private httpClient: HttpClient, private router: Router, private toastrService: ToastrService) { }

  getList(): Observable<ListResponseModel<Portal>> {
    return this.httpClient.get<ListResponseModel<Portal>>(ApiUrl.url + "Portal/getList");
  }

  getById(id: number): Observable<ObjectResponseModel<Portal>> {
    return this.httpClient.get<ObjectResponseModel<Portal>>(ApiUrl.url + "Portal/getById?Id=" + id);
  }

  getByName(portalName: string): Observable<ObjectResponseModel<Portal>> {
    return this.httpClient.get<ObjectResponseModel<Portal>>(ApiUrl.url + "Portal/getByName?portalName=" + portalName);
  }

  add(portal: Portal) {
    return this.httpClient.post<ObjectResponseModel<Portal>>(ApiUrl.url + "Portal/add", portal);
  }

  update(portal: Portal) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Portal/update", portal);
  }

  delete(id: number) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Portal/delete?Id=" + id, "");
  }

}
